import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import ScrollToTop from "react-scroll-to-top";
import GetStartedNow from "../GetStartedNow";
import {Link} from 'react-router-dom'
const logo = require('../../assets/images/logo_footer.png')
function Footer(props) {
    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            setMobile({ mobile: true });
        }
    }, []);
    return (
        <div>
            <GetStartedNow />
            <div className="footer-main">
                <ScrollToTop smooth color="#005070" />
                <div className="footer-bg">
                <Container>
                    <div className={"content-footer"}>
                        <Row className="pt-4">
                            <Col md="3" className="footer-left-content">
                                <Link to={'/'} className="footer-header">
                                    <p className="cloud-head">
                                       <img className="footer-logo" src={logo} alt="Logo" height='40px'/>
                                    </p>
                                </Link>
                                {/* <div className="footer-pattern">
                                    <img
                                        src={require("../../assets/images/footer_pattern_detasad.png")}
                                        alt=""
                                        className="pattern-image"
                                    />
                                </div> */}
                            </Col>
                            <Col md="6" className={!mobile ? "text-left" : ""}>
                                <p className="footer-row">Quick Links</p>
                                <Row>
                                    <Col md="6" className="footer-center-content">
                                        <Link to={{pathname : process.env.REACT_APP_HOME}} target={"_blank"} className="row-data">Home</Link>
                                        <Link  to={{pathname : process.env.REACT_APP_PARTNERS}} target={"_blank"} className="row-data">Partners</Link>
                                        <Link to={{pathname : process.env.REACT_APP_NEWS}} target={"_blank"} className="row-data">Media Center</Link>
                                    </Col>
                                    <Col md="6" className="footer-center-content">
                                        <Link to={{pathname : process.env.REACT_APP_ABOUT_DETASAD}} target={"_blank"} className="row-data">About DETASAD</Link>
                                        <Link  to={{pathname : process.env.REACT_APP_CAREERS}} target={"_blank"} className="row-data">Careers</Link>
                                        <Link to={{ pathname: process.env.REACT_APP_CONTACTUS }} target={"_blank"} className="row-data">Contact Us</Link>
                                    </Col>
                                </Row>

                                <p className="footer-row">ICT Services</p>
                                <Row>
                                    <Col md="12" className="footer-center-content">
                                        <Link to={{pathname : process.env.REACT_APP_VSAT}} target={"_blank"} className="row-data">Connectivity & Corporate Networks - VSAT</Link>
                                        <Link to={{ pathname: process.env.REACT_APP_DATA_CENTER }} target={"_blank"} className="row-data">Data Center</Link>
                                        <Link to={'/'}  className="row-data">DETASAD Cloud</Link>
                                        <Link to={{ pathname: process.env.REACT_APP_DEPLOYMENT_SOLUTIONS }} target={"_blank"}  className="row-data">Deployment Solutions</Link>
                                        <Link to={{ pathname: process.env.REACT_APP_MANAGED_SERVICES }} target={"_blank"}  className="row-data">Managed Services</Link>
                                    </Col>
                                </Row>

                                <p className="footer-row">Solutions</p>
                                <Row>
                                    <Col md="6" className="footer-center-content">
                                        <Link onClick={()=>window.open('https://www.detasad.com/fleet-solutions/', '_blank')} className="row-data">Fleet Solutions</Link>
                                        <Link  onClick={()=>window.open('https://www.detasad.com/ai-solutions/', "_blank")} className="row-data">Artificial Intelligence Solutions</Link>
                                    </Col>

                                    <Col md="6" className="footer-center-content">
                                        <Link  onClick={()=>window.open('https://www.detasad.com/solar-surveillance-solutions/', '_blank')}  className="row-data">Solar Surveillance Solutions</Link>
                                        <Link onClick={()=>window.open('https://www.detasad.com/detasad-ultimate-soc-solutions/', '_blank')}  className="row-data">Cyber Security Solutions</Link>
                                    </Col>
                                </Row>
                             </Col>
        
                            <Col md={3} className={!mobile ? "text-left" : ""}>
                                 <p className="footer-row">Newsletter Sign up</p>
                                 <p className="news-text">By subscribing to our mailing list you will always be updated with the latest news from us.</p>
                                 <form className="input-group">
                                    <input type="email" required={true} className="form-control" placeholder="Your Email"/>
                                    <div className="input-group-append">
                                        <button className="btn btn-join-us" type="submit">Join Us</button>
                                    </div>
                                </form>
                                <div className="social-icons mt-4">
                                    <span onClick={()=>window.open("https://www.linkedin.com/company/detecon-al-saudia-company-limited",'_blank')} className="bg-white p-1 rounded social-icon"><i aria-hidden="true" className="fa fa-linkedin"></i></span>
                                    <span onClick={()=>window.open("https://twitter.com/detasad",'_blank')} className="bg-white p-1 rounded social-icon ml-3"><i aria-hidden="true" className="fa fa-twitter"></i></span>
                                    <span onClick={()=>window.open("https://www.youtube.com/channel/UCwY8UomKcwqw6RhHn_0xVbw",'_blank')} className="bg-white p-1 rounded social-icon ml-3"><i aria-hidden="true" className="fa fa-youtube"></i></span>
                                </div>

                                <p className="contact-text mt-4">Telephone</p>
                                <a href="tel:+966 92000 1221" className="contact-href">+966 92000 1221</a>
                                <p className="contact-text">Email</p>
                                <a href="mailto:info@detasad.com" className="contact-href">info@detasad.com </a>

                            </Col>
                        </Row>
                        {/* <div className="bottom-clearfix"></div> */}

                        <div className="footer-hr bottom-clearfix"></div>
                        

                    </div>
                </Container>
                    <div className="footer-text">
                        <Container>© 2021 All rights reserved. Powered and Secured by <Link to={'/'} className="cloud-text">DETASAD Cloud.</Link></Container>
                    </div>
                </div>  
            </div>
        </div>
        
    );
}

export default Footer;


